export { Holidays as default } from './Holidays.js'
